import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";
import {ORGANIZATION_SERVER} from "@/api";

const personQualification = new RestResource({server: ORGANIZATION_SERVER, resource: 'personQualification'});

personQualification.unbind = (personQualificationId) => {
    let url = `${ORGANIZATION_SERVER}/personQualification/${personQualificationId}`;
    return new Promise((resolve, reject) => {
        athubAxios.delete(url).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default personQualification;